import React,{useState, useEffect} from 'react';
import Breadcrumbs from './Breadcrumbs';
import './todo.css';
//import 'fa-icons';

// const price =[200,300,350,400,450,500,600];
// const newp = price.filter((elem, index)=>{
//     return elem < 500;
// })
//to get the data from LS
const getLocalItems = () =>{
    let list = localStorage.getItem('list');
    console.log(list);
    if(list){
        return JSON.parse(localStorage.getItem('list'));
    }
    else{
        return [];
    }
}

const Todo = () => {
    const [inputData, setInputData]= useState('');
    const [items, setitems]= useState(getLocalItems());
    const [toggleSubmit, setToggleSubmit] = useState(true);
   const [isEdititem, setIsEditItem]= useState(null);
    //add item
const additems= ()=>{
    if(!inputData){
        alert("Pls fill data") 
    }
    else if(inputData && !toggleSubmit){
        setitems(
            items.map((elem)=>{
                if(elem.id === isEdititem){
                    return{...elem, name:inputData}
                }
                return elem;
            })
        )
        setToggleSubmit(true);
        setInputData('');
        setIsEditItem(null);

    }
    
    else{
        const allInputData = {id:new Date().getTime().toString(),name:inputData};
        setitems([...items, allInputData]);
    setInputData('');

    }
    
    
}
//delete item
const deleteItem = (indxe) =>{
    const updateitems = items.filter((elem)=>{
        return indxe !== elem.id;
    });
    setitems(updateitems);

}
//delete all data
const removeAll = () =>{
    setitems([]);
}
// add data to localStorage
useEffect(() => {
   localStorage.setItem('list',JSON.stringify(items))
}, [items]);


//update item


const editItem = (id) =>{
    let newEditItem = items.find((elem)=>{
        return elem.id === id

    });
    console.log(newEditItem);
    setToggleSubmit(false);
    setInputData(newEditItem.name);
    setIsEditItem(id);

}
    return (
        <>
          <Breadcrumbs name="ToDo List" linename="todo"/>
         <div className="main-div">
         <div className="child-div">
         <figure>
            <figcaption>Add Your ToDo List</figcaption>
         </figure>
         <div className="addItems">
         <input type="text" value={inputData}
           placeholder="Add Items...." 
         onChange={(e)=>setInputData(e.target.value)}/>
       
{
    toggleSubmit ?  <i className="fa fa-plus add-btn"
          title="add Items" onClick={additems}></i>:
           <i className="far fa-edit add-btn"
          title="Edit Items" onClick={additems}></i>
}


         </div>
         <div className="showItems">
         {
             items.map((elem)=>{
                 return(
                    <div className="eachItem" key={elem.id}>
                 <h3>{elem.name}</h3>
                 <div className="todo-btn">
                 <i className="far fa-edit add-btn"
                  title="Edit Items"
                   onClick={()=>editItem(elem.id)}></i>

                 <i className="far fa-trash-alt add-btn"
                  title="Delete Items"
                   onClick={()=>deleteItem(elem.id)}></i>

                 </div>
               
             </div>

                 )

             })
         }
            
         </div>
         <div className="showItems">
             <button onClick={removeAll}  className="btn effect04" data-sm-link-text="Remove All"><span style={{color:"#fff"}}>  Check List</span></button>
         </div>

         </div>

         </div>
        </>
    )
}

export default Todo;
